module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "inner-content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0d3c12c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 314
// module chunks = 1